//Controller of the overlay

export default function (
    $log,
    $sbFileReader,
    $mdDialog,
    images,
    currentIndex,
    $sbExternalService,
    Analytics
) {
    "ngInject";
    var vm = this;

    vm.images = images;
    vm.imagesAdditionalInfo = [];
    vm.currentIndex = currentIndex;
    vm.$sbExternalService = $sbExternalService;

    vm.close = close;
    vm.imageLoaded = imageLoaded;
    function close() {
        $mdDialog.cancel();
    }

    function imageLoaded(atIndex) {
        if (vm.imagesAdditionalInfo[atIndex]) {
            return;
        }

        if (vm.images[atIndex].image_url) {
            $sbFileReader
                .getLocationAndTimestampTags(vm.images[atIndex].image_url)
                .then((metadata) => {
                    const convertedMetadata =
                        convertMetadataToPresentableStrings(metadata);

                    const hasNOGpsData =
                        !convertedMetadata.gpsLatitude &&
                        !convertedMetadata.gpsLongitude &&
                        !convertedMetadata.gpsAltitude;

                    const hasNOTimestamp = !convertedMetadata.timestamp;

                    if (hasNOGpsData) {
                        console.warn(
                            "No GPS metadata found for image at index " +
                                atIndex
                        );
                    }

                    if (hasNOTimestamp) {
                        console.warn(
                            "No timestamp found for image at index " + atIndex
                        );
                    }

                    if (hasNOGpsData && hasNOTimestamp) {
                        return;
                    }

                    vm.imagesAdditionalInfo[atIndex] = convertedMetadata;
                })
                .catch((e) => $log.error(e));
        }
    }

    function convertMetadataToPresentableStrings(metadata) {
        if (metadata.dateTimeOriginal !== metadata.dateTimeDigitized) {
            Analytics.trackEvent(
                "Image metadata",
                "Difference in creation date"
            );
        } else {
            Analytics.trackEvent("Image metadata", "Equal in creation date");
        }
        const geolocation = $sbExternalService.formatGeolocation(metadata);
        const timestamp = $sbExternalService.formatTimestamp(
            metadata?.dateTimeDigitized || metadata?.dateTimeOriginal
        );

        return { timestamp, ...geolocation };
    }
}
